__turbopack_context__.v({
  "container": "UdXawq_container",
  "graph": "UdXawq_graph",
  "shimmer": "UdXawq_shimmer",
});
